import { useEffect, useRef, useState } from "react";
import axios from "axios";
import "./AuthPopup.css";
import { saveSession } from "../utils/session";
import { API_URL } from "../services/api";

function LoginPopup({ onClose, onGoToRegister }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [verPwd, setVerPwd] = useState(false);
  const [entrando, setEntrando] = useState(false);
  const [aviso, setAviso] = useState(null); // { tipo: "error" | "wait", texto }
  const emailRef = useRef(null);

  useEffect(() => {
    emailRef.current?.focus();
  }, []);

  // Cerrar con Escape
  useEffect(() => {
    const onKey = (e) => {
      if (e.key === "Escape") onClose();
    };
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [onClose]);

  const handleLogin = async (e) => {
    e.preventDefault();
    setAviso(null);

    if (!email.trim() || !password) {
      setAviso({ tipo: "error", texto: "Escribe tu correo y tu contraseña." });
      return;
    }

    setEntrando(true);
    try {
      const response = await axios.post(`${API_URL}/users/login`, {
        email: email.trim().toLowerCase(),
        password
      });
      const { token, user } = response.data;
      await saveSession(token, user);

      window.location.href = user.role === "admin" ? "/admin" : "/dashboard";
    } catch (err) {
      const status = err.response?.status;
      const msg = err.response?.data?.message;

      // 403 es la cuenta pendiente de aprobación: no es un fallo del usuario
      if (status === 403) {
        setAviso({
          tipo: "wait",
          texto:
            msg || "Tu cuenta aún no está aprobada. Tu entrenador te dará acceso en breve."
        });
      } else if (status === 404 || status === 401) {
        setAviso({ tipo: "error", texto: "El correo o la contraseña no coinciden." });
      } else if (err.response) {
        setAviso({ tipo: "error", texto: msg || "No se pudo entrar. Inténtalo de nuevo." });
      } else {
        setAviso({
          tipo: "error",
          texto: "No hay conexión con el servidor. Inténtalo en un momento."
        });
      }
      setEntrando(false);
    }
  };

  return (
    <div className="auth-overlay" onClick={onClose}>
      <div
        className="auth-card"
        role="dialog"
        aria-modal="true"
        aria-labelledby="auth-login-title"
        onClick={(e) => e.stopPropagation()}
      >
        <button type="button" className="auth-close" onClick={onClose} aria-label="Cerrar">
          ×
        </button>

        <h2 className="auth-title" id="auth-login-title">
          Entra a tu entrenamiento
        </h2>
        <p className="auth-sub">Con el correo que diste al crear la cuenta.</p>

        <form className="auth-form" onSubmit={handleLogin} noValidate>
          <div className="auth-field">
            <label htmlFor="login-email">Correo electrónico</label>
            <input
              id="login-email"
              ref={emailRef}
              type="email"
              inputMode="email"
              autoComplete="email"
              value={email}
              onChange={(e) => {
                setEmail(e.target.value);
                setAviso(null);
              }}
            />
          </div>

          <div className="auth-field">
            <label htmlFor="login-password">Contraseña</label>
            <div className="auth-password">
              <input
                id="login-password"
                type={verPwd ? "text" : "password"}
                autoComplete="current-password"
                value={password}
                onChange={(e) => {
                  setPassword(e.target.value);
                  setAviso(null);
                }}
              />
              <button
                type="button"
                className="auth-password-toggle"
                onClick={() => setVerPwd((v) => !v)}
              >
                {verPwd ? "Ocultar" : "Ver"}
              </button>
            </div>
          </div>

          {aviso && (
            <p
              className={
                "auth-alert " +
                (aviso.tipo === "wait" ? "auth-alert-wait" : "auth-alert-error")
              }
              role="alert"
            >
              {aviso.texto}
            </p>
          )}

          <div className="auth-actions">
            <button type="submit" className="auth-btn auth-btn-primary" disabled={entrando}>
              {entrando && <span className="auth-spinner" aria-hidden="true" />}
              {entrando ? "Entrando" : "Entrar"}
            </button>
          </div>
        </form>

        {onGoToRegister && (
          <p className="auth-switch">
            ¿Todavía no tienes cuenta?{" "}
            <button type="button" onClick={onGoToRegister}>Créala aquí</button>
          </p>
        )}
      </div>
    </div>
  );
}

export default LoginPopup;
